<div class="price-container" *ngIf="!priceOnRequest; else priceOnRequestTemplate">
  <div class="content {{type}} {{sameLine ? 'same-line' : ''}}">
    <div class="striked-price">{{strikedPrice}}</div>
    <div class="price {{strikedPrice ? 'colored' : 'native'}}">
      <span class="from-label" *ngIf="isRanged">{{ 'product.price.from' | translate }}</span>
      {{price}}
    </div>
  </div>
</div>
<ng-template #priceOnRequestTemplate>
  <div class="price-container">
    <div class="content {{type}} {{sameLine ? 'same-line' : ''}}">
      <div class="price native">{{ priceOnRequest }}</div>
    </div>
  </div>
</ng-template>
